import { render } from "./lock.svg?vue&type=template&id=2aa4c550"
const script = {}
script.render = render

export default script